module.exports = __webpack_public_path__ + "static/media/JVC_Logo.68251487.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/JVC_Logo.svg
// module id = 32
// module chunks = 1